import BaseCrudRepository, { networkBoundResource, unwrapApiWrapper } from '@/repositories/BaseCrudRepository';
import { Observable } from 'rxjs';
import Resource from '@/repositories/Resource';
import ApiWrapper from '@/repositories/data/ApiWrapper';

export default class PositionableCrudRepository<I, T, F> extends BaseCrudRepository<I, T, F> {
    public static isInstance<I, T, F>(
        target: BaseCrudRepository<I, T, F>,
    ): target is PositionableCrudRepository<I, T, F> {
        return typeof (target as any)['movePosition'] === 'function';
    }

    public movePosition(id: I, up: boolean): Observable<Resource<T>> {
        const data = {
            id: id,
            up,
        };
        const observable = this.client.post<ApiWrapper<T>>('move-position', data, { baseUrl: this.baseUrl });
        return networkBoundResource(unwrapApiWrapper(observable));
    }
}
